/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_SubtitleInputs */



/**
* | output |
* | --- |
* | "Generate referral links to share — customers who sign up through them are attributed to you." |
*
* @param {Partner_Referral_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_subtitle = /** @type {((inputs?: Partner_Referral_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie Empfehlungslinks zum Teilen – Kunden, die sich darüber registrieren, werden Ihnen zugeordnet.")
	return /** @type {LocalizedString} */ ("Generate referral links to share — customers who sign up through them are attributed to you.")
});